//confirm.js
import Modal from "./components/Modal";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
export default function TxList({ txs, ree }) {
  const [modalOpen, setModalOpen] = useState(false);

  const close = () => setModalOpen(false);
  const open = () => setModalOpen(true);
  if (txs.length === 0) return null;

  return (
    <>
      {txs.map((item) => (
        <div key={item}>
          <div>
            <label>{item.hash}</label>
            <AnimatePresence
              // Disable any initial animations on children that
              // are present when the component is first rendered
              initial={false}
              // Only render one component at a time.
              // The exiting component will finish its exit
              // animation before entering component is rendered
              exitBeforeEnter={true}
              // Fires when all exiting nodes have completed animating out
              onExitComplete={() => null}
            >
              {ree && <Modal modalOpen={ree} handleClose={close} />}
            </AnimatePresence>
          </div>
        </div>
      ))}
    </>
  );
}
